export const mask = (input: string) => {
    if(!input || input.length<=0){
      return ""
    }
    // let indices = [];
    // for (var i = 0; i < input.length; i++) {
    //   if (input[i] === " ") indices.push(i);
    // }

    // if (input.length <= 4){
    //   return input; // Nothing to mask
    // }

    // let buf = input.split('').fill('X', 4).join('');
    // for (var j = 0; j < indices.length; j++) {
    //   buf = replaceAt(buf, indices[j], ' ');
    // }
    // return String(buf);
    const splittedName = input.toUpperCase().split(' ')
    splittedName.forEach((val,i)=>{
      if(i===0){
        return;
      }
      if(/^[a-zA-Z]+$/.test(val)){
        splittedName[i] = `${val.charAt(0).toLocaleUpperCase()}${'x'.repeat(val.length-1)}` 
      }else if(val.length >1){
        let nameContent = val.split('');
        // let prevChar = nameContent[0]
        for(let l=1; l<nameContent.length;l++){
            if(/^[a-zA-Z]+$/.test(nameContent[l])){
              nameContent[l] = 'x'
            }
            // else{
            //   if(l+1 < nameContent.length){
            //     nameContent[l-1] =prevChar
            //     l++;
            //   }
            // }
            // prevChar = nameContent[l]
        }
        splittedName[i] = nameContent.join('')
      }
    })
    return splittedName.join(' ')
    
}

// const replaceAt = (val: string, index: number, replacement: string) => {
//     return val.substring(0, index) + replacement + val.substring(index + replacement.length);
// }